


@Pipe({
  name: 'DynamicFilesTitlePipe'
})
export class DynamicFilesTitlePipe implements PipeTransform {
  transform(file_obj: any[]) {


    let out_str = [];
    file_obj = jsonParse(file_obj);

    if (typeof file_obj == 'object') {
      if (file_obj && (file_obj.length)) {

        file_obj.forEach(file => {
          out_str.push(file.fileName);
        })


        return out_str.toString() || []; //out_str || ''
      }
    }
    else {
      return ''
    }
  }
}

import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, Input, ChangeDetectorRef, OnChanges, Output, EventEmitter, ElementRef, ViewChild, Renderer2, AfterViewInit, Pipe, PipeTransform, HostListener, ContentChild } from '@angular/core';
import { ColumnDetailsComponent } from './column-details/column-details.component';
import { DomSanitizer } from '@angular/platform-browser';
import { CdkVirtualScrollViewport, ScrollDispatcher } from '@angular/cdk/scrolling';
import * as moment from 'moment';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { jsonParse, removeDuplicate, sortListSeq } from '../../functions/shared-functions';
import { viewDocument } from '../files/files.component';



export const skip = 0;
export const take = 20;

@Component({
  selector: 'app-tallint-table',
  templateUrl: './tallint-table.component.html',
  styleUrls: ['./tallint-table.component.scss'],
  providers: []
})

export class TallintTableComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() table_records = [];
  @Input() table_columns = [];
  @Input() total_count;
  @Input() multi_select;
  @Input() loading;
  @Input() edit;
  @Input() selected_entries;
  @Input() display_filter;
  @Output() fetchEntries = new EventEmitter();
  @Output() checkboxSelected = new EventEmitter();
  @Output() cellClicked = new EventEmitter();
  @Output() scrollingIndex = new EventEmitter();
  @Output() gridLayoutChanges = new EventEmitter();
  @ContentChild("content_child") content_child: any;
  @Input() current_scrolling_index;
  @Input() nested;
  @Input() fetching_entries;
  @Input() item_size;
  @Input() export;
  @Input() export_records;
  @Input() export_callback;
  @Input() export_ready;
  @Input() file_name;
  @Input() table_code;
  @Input() filter_template_list;
  @Input() grid_configuration;
  @Input() start_page: number = 1;
  @Input() limit;


  @Input() form_masters;
  @Input() form_fields;
  @Input() formatted_table_records;
  @Input() pagination_type;

  @Input() enable_sort;
  @Input() local_sort;

  @Input() table_configuration_flag;
  @Input() enable_summary = 1;
  @Input() summary;
  @Input() session;
  @Input() enable_action;
  @Input() action_list = []
  @Input() unique_key;

  @Input() limit_list;
  @Input() current_limit;
  @Input() no_data_message;

  @Input() loader_column_name;
  @Input() nested_pattern = 1;
  @Input() nested_nested;
  @Input() enable_index;
  start: any = undefined;
  pressed: boolean = false;
  startX: any;
  startWidth: any;
  Math = Math;
  random_width = [];
  display_subrow = false;
  sort_flag = true;
  pointer = true;
  quickTemplate = '<i class="fa fa-tasks"></i>'
  // fetchMultipleEntries: TableCheckedValues = new TableCheckedValues();

  // fetching_entries;
  // selected_entries = [];
  // selected_entries = [];

  skip;
  take;

  table_height;
  table_max_height;

  filter: Array<TallintTableColumnFilter>;
  sort: TallintTableColumnSort;

  select_all = false;

  tallint_table_columns = [];
  hide_table;

  limit_form: UntypedFormGroup = new UntypedFormGroup({
    limit: new UntypedFormControl(10)
  })

  parseInt = parseInt;

  @ViewChild("virtual_scroll", { static: false }) virtual_scroll: CdkVirtualScrollViewport;
  @ViewChild("tallint_table", { static: false }) tallint_table_ref: ElementRef;
  @ViewChild("virtual_scroll", { static: false }) cdk_view_port: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewport: CdkVirtualScrollViewport;
  table = document.getElementById('tableId');
  random_id = 'tallite-table-' + Math.floor((Math.random() * 10000) + 1) + Date.now();
  random_id_row = 'tallite-table-row' + Math.floor((Math.random() * 10000) + 1) + Date.now();
  timestamp;
  last_scroll_index = 0;

  footer_position;
  viewport_present: any;
  table_tr_offset;
  selectedRowIndex: number = -1;
  selectedColIndex: number = -1;
  scrolling = 0;
  listener: () => void;
  primary_actions = [];
  secondary_actions = [];

  constructor(
    private change_detector: ChangeDetectorRef,
    private renderer: Renderer2,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private scrollDispatcher: ScrollDispatcher
  ) {
    for (let i = 0; i < 14; i++) {
      this.random_width[i] = [];
      for (let j = 0; j < 10; j++) {
        this.random_width[i][j] = this.randomNumber() + 'px';
      }
    }
  }

  ngOnInit() {
    try {
      document.getElementById(this.random_id).addEventListener('keydown', (event: any) => {
        if (event.target.id == this.random_id && this.table_records && this.table_records.length) {
          if (event && this.timestamp) {
            if (event.keyCode == 40) { //Arrow down should shift row by 1
              if (this.table_records.length - 1 > this.selectedRowIndex) {
                this.selectedRowIndex += 1;
              }
              if (this.table_records && this.table_records.length) {
                if (this.table_records.length / 2 > this.selectedRowIndex) {
                  this.viewport.scrollToIndex(this.selectedRowIndex + 0, 'smooth');
                }
                else {
                  this.viewport.scrollToIndex(this.selectedRowIndex + 5, 'smooth');
                }
              }
            }
            else if (event.keyCode == 38) { //Arrow up should shift row by -1
              if (this.selectedRowIndex > 0) {
                this.selectedRowIndex -= 1;
              }
              if (this.table_records && this.table_records.length) {
                if (this.table_records.length / 2 > this.selectedRowIndex) {
                  this.viewport.scrollToIndex(this.selectedRowIndex + 0, 'smooth');
                }
                else {
                  this.viewport.scrollToIndex(this.selectedRowIndex + 5, 'smooth');
                }
              }

            }
            else if (event.keyCode == 37) { //Arrow left should shift column by -1\

              // document.getElementById(this.random_id).removeAttribute('tabindex');
              if (this.selectedColIndex > 0) {
                this.selectedColIndex -= 1;
              }
              // setTimeout(() => {
              //   document.getElementById(this.random_id).setAttribute('tabindex', '1')
              //   this.change_detector.detectChanges()
              // }, 200)

            }
            else if (event.keyCode == 39) { //Arrow right should shift row by 1

              // document.getElementById(this.random_id).setAttribute('tabindex', '-1')
              // document.getElementById(this.random_id).removeAttribute('tabindex');
              this.selectedColIndex += 1;

              // setTimeout(() => {
              //   document.getElementById(this.random_id).setAttribute('tabindex', '1')
              //   this.change_detector.detectChanges()
              // }, 200)
            }
            else if (event.keyCode == 13) {
              this.triggerCellClick(this.tallint_table_columns[this.selectedColIndex].function_name, this.table_records[this.selectedRowIndex], this.tallint_table_columns[this.selectedColIndex], null, event, null)
            }

            // if (document.getElementById(this.timestamp + this.random_id + 'tallite-td' + this.selectedRowIndex + this.selectedColIndex)) {
            //   setTimeout(() => {
            //     document.getElementById(this.timestamp + this.random_id + 'tallite-td' + this.selectedRowIndex + this.selectedColIndex).scrollIntoView()
            //   })
            // }

            // setTimeout(() => {
            //   this.viewport.scrollToIndex(this.selectedRowIndex)
            // }, 200)

          }
        }

      })
    }
    catch (err) {
      console.log(err)
    }


    this.limit_list = this.limit_list ? this.limit_list : [{ title: 10, code: 10 }, { title: 20, code: 20 }, { title: 40, code: 40 }, { title: 80, code: 80 }]
    // this.current_limit = this.current_limit ? this.current_limit : 40;
    if (!this.selected_entries) {
      this.selected_entries = [];
    }

    // fromEvent(window, 'resize')
    // 	.pipe(
    // 		debounceTime(10),
    // 		takeUntil(this.destroy$),
    // 	)
    // 	.subscribe(() => this.viewportComponent.checkViewportSize())
    // ;
    this.table_configuration_flag = false;
    // this.filterEntries();
    if (this.loading == null || undefined) {
      this.loading = false;
    }

    this.init();
    // this.change_detector.det


    // if (this.formatted_table_records && this.table_records && this.table_records.length) {
    //   for (let i = 0; i < this.table_records.length; i++) {
    //     this.table_records[i].data = this.formatted_table_records[i];
    //   }
    // }
    // if (this.cdk_view_port) {
    //   this.viewport_present = 1;
    //   this.cdk_view_port.elementScrolled().subscribe((ev: any) => {
    //     if (ev && ev.target && ev.target.scrollTop) {
    //       console.log(ev.target.scrollTop)
    //       this.table_tr_offset = ev.target.scrollTop;
    //       this.change_detector.detectChanges();
    //     }
    //     else {
    //       this.table_tr_offset = 0;
    //       this.change_detector.detectChanges();
    //     }
    //   });
    // }

    // this.scrollDispatcher.scrolled().pipe(
    //   filter(event => this.virtual_scroll.getRenderedRange().end === this.virtual_scroll.getDataLength())
    // ).subscribe(event => {
    //   console.log(event);
    //   this.change_detector.detectChanges();
    // })

  }

  getYPosition(e: Event): number {
    return (e.target as Element).scrollTop;
  }

  ngAfterViewInit() {
   try{
    this.footer_position = this.virtual_scroll['elementRef'].nativeElement.offsetHeight;
   }
   catch(Err){

   }

    // this.scrollDispatcher.scrolled().pipe(
    //   filter(event => this.virtual_scroll.getRenderedRange().end === this.virtual_scroll.getDataLength())
    // ).subscribe(event => {
    //   console.log(event);
    //   this.getNextBatch(event);
    //   //this.cd.detectChanges();
    // })

  }

  resizeTable(event, column) {
    this.start = event.target;
    this.pressed = true;
    setTimeout(() => {
      this.pointer = false;
    })
    this.startX = event.clientX;
    this.startWidth = this.start.clientWidth;
    this.renderer.listen('window', 'mousemove', (event) => {
      if (this.pressed) {
        let width = this.startWidth + (event.clientX - this.startX);
        // let index = this.start.cellIndex;
        if (column != null) {
          // if (column.width) {
          //   // column.width += width;
          // }
          // else {
          column.width = width;
          if (this.table_columns && this.table_columns.length) {
            let index = this.table_columns.findIndex(data => data.colId == column.colId);
            if (index > -1) {
              this.table_columns[index].width = width;
            }
          }
        }
        this.change_detector.detectChanges();
        event.preventDefault();
      }
    });
    this.renderer.listen('window', 'mouseup', (event) => {
      column = null;
      if (this.pressed) {
        this.pressed = false;
        this.pointer = true;
        this.gridLayoutChanges.emit(this.table_columns);
      }
    });
  }

  limitChanged(ev) {

  }

  init() {
    // this.virtual_scroll.nativeElement.scrollTop = 0;
    // if (this.virtual_scroll && this.virtual_scroll['elementRef'] && this.virtual_scroll['elementRef'].nativeElement) {
    //   this.virtual_scroll['elementRef'].nativeElement.scroll(0, 0);
    // }
    this.filter = [];
    this.skip = skip;
    this.take = take;
    this.sort = new TallintTableColumnSort();

    this.table_height = this.total_count ? (this.total_count * 24.67) + 60 : 100;
    // this.table_max_height = (this.total_count * 25.33) + 60;
    if (this.multi_select) {
      try {
        if (this.selected_entries.length) {
          let flag = true;
          this.selected_entries.forEach(element => {
            if (this.table_records.indexOf(element) == -1) {
              flag = false;
            }
          });
          this.select_all = flag && this.selected_entries.length == this.table_records.length;
        }
        else {
          this.select_all = false;
        }
      } catch (err) {
        this.select_all = false;
      }
    }

    if (this.enable_index) {
      this.table_records.forEach((r, index) => {
        r.index = index;
      })
    }


    this.initializeColumns();
    this.change_detector.detectChanges();
  }

  ngOnChanges(ev) {
    if (ev.total_count || (ev.table_columns && ev.table_columns.length)) {
      this.init();
    }
    if (ev.table_records) {
      this.fetching_entries = 0;
      this.table_records = ev.table_records.currentValue || this.table_records; //getting lastest update data or update existing records
      if (this.unique_key && this.selected_entries && this.selected_entries.length && this.table_records && this.table_records.length) {
        let new_selected = []
        this.selected_entries.forEach(data => {
          let index = this.table_records.findIndex(data_row =>
            data_row[this.unique_key] == data[this.unique_key]
          )
          if (index > -1) {
            this.table_records[index].row_selected = true;
            new_selected.push(this.table_records[index])
          }
        })

        if (this.selected_entries.length != new_selected.length) {
          this.selected_entries = new_selected;
          if (this.checkboxSelected) {
            this.checkboxSelected.emit(this.selected_entries);
          }

        }
      }
      else {
        if (this.table_records && this.table_records.length) {
          this.selected_entries = [];
          this.table_records.forEach(record => {
            if (record.row_selected) {
              this.selected_entries.push(record)
            }
          })
        }
        else {
          this.selected_entries = [];
          if (this.checkboxSelected) {
            this.checkboxSelected.emit(this.selected_entries);
          }

        }
      }


      try {
        if (!this.item_size) {
          if (document.getElementById(this.random_id_row).offsetHeight > 0) {
            this.item_size = document.getElementById(this.random_id_row).offsetHeight;
          }
        }

      }
      catch (err) {
        console.log(err)
        this.item_size = 25;
      }
      this.checkAllSelected()
      this.change_detector.detectChanges();

    }
    if (ev && ev.selected_entries) {
      this.selected_entries = ev.selected_entries.currentValue;
      if (this.selected_entries && this.selected_entries.length && this.unique_key) {
        let new_selected = []
        this.selected_entries.forEach(record => {
          let index = this.table_records.findIndex(data => data[this.unique_key] == record[this.unique_key]);
          if (index > -1) {
            this.table_records[index]['row_selected'] = true;
            new_selected.push(this.table_records[index]);
          }
        })
        if (this.selected_entries.length != new_selected.length) {
          this.selected_entries = new_selected;
          if (this.checkboxSelected) {
            this.checkboxSelected.emit(this.selected_entries);
          }

        }

      }
      else {
        if (this.selected_entries && this.selected_entries.length && !this.unique_key) {

        }
        else {
          if (this.table_records && this.table_records.length) {
            this.table_records.forEach(item => {
              item['row_selected'] = false;
            })
          }
        }

      }
      if (this.unique_key && this.selected_entries && this.selected_entries.length) {
        this.selected_entries = removeDuplicate(this.selected_entries, this.unique_key);
      }


    }
    if (ev.session && ev.session.currentValue) {
      if (ev && ev.current_scrolling_index) {
        if (ev.current_scrolling_index.currentValue) {
          setTimeout(() => {
            this.scrollIntoIndex(ev.current_scrolling_index.currentValue)
          }, 1000)
        }
      }
    }

    if (ev && ev.limit && ev.limit.currentValue) {
      this.current_limit = ev.limit.currentValue;
      this.limit_form.controls.limit.patchValue(ev.limit.currentValue);
      this.change_detector.detectChanges();
    }
    if (ev && ev.startPage && ev.startPage.currentValue) {
      this.start_page = ev.startPage.currentValue;
    }
    if (ev && ev.table_columns && ev.table_columns.currentValue) {
      this.table_columns = ev.table_columns.currentValue;
      this.initializeColumns();

    }
    if (ev && ev.action_list) {
      this.action_list = ev.action_list.currentValue;

      if (this.action_list && this.action_list.length) {
        this.primary_actions = this.action_list.filter(d => d.primary);
        this.secondary_actions = this.action_list.filter(d => !d.primary);
      }

    }
    if (ev.fetching_entries) {
      this.fetching_entries = ev.fetching_entries.currentValue
    }
  }

  exportToExcelParent() {
    if (this.export_records && this.export_records.length > 0) {
      let exp_data = [];
      let rows = {};
      this.export_records.forEach(row => {
        this.tallint_table_columns.forEach(col => {
          if (col['visible']) {
            let prop = col['property']
            let titles = col['title']
            rows[titles] = row[prop];
          }
        })
        if (rows)
          exp_data.push(rows);
        rows = {};
      })
      // this.export_excel_srv.exportExcel(exp_data, this.file_name || 'Details');
      this.export_records = [];
      this.export_ready = false;
      this.change_detector.detectChanges();
    }
  }

  checkAllSelected() {
    if (this.table_records && this.table_records.length) {
      let all_select = true;
      for (let i = 0; i < this.table_records.length; i++) {
        if (!this.table_records[i].row_selected) {
          all_select = false;
          break;
        }
      }
      if (all_select) {
        this.select_all = true;
      }
      else {
        this.select_all = false;
      }
    }
    else {
      this.select_all = false;
    }
  }

  initializeColumns() {
    if (this.table_records && this.table_records.length) {
      if (!(this.table_columns && this.table_columns.length)) {
        let columns = Object.keys(this.table_records[0]);
        if (columns && columns.length) {
          this.tallint_table_columns = [];
          columns.forEach((column, index) => {
            let col = new TallintTableColumn();

            try {
              if (isNaN(this.table_records[0][column])) {
                var d = moment(this.table_records[0][column], moment.ISO_8601);
                if (d.isValid()) {
                  col.setData(column, column, 'date');
                }
                else {
                  col.setData(column, column);
                }

              }
              else {
                col.setData(column, column);
              }
              //&& isNaN(this.table_records[0][column]))
            } catch (error) {
              console.log(error)
              col.setData(column, column);
            }
            this.filter[index] = new TallintTableColumnFilter(column, null, null);
            col.visible = true;
            this.tallint_table_columns.push(col);
          })
        }
      }
      else if (this.table_columns && this.table_columns.length) {
        this.tallint_table_columns = [];
        if (typeof this.table_columns == 'object' && this.table_columns.length) {
          this.table_columns.forEach((column, index) => {
            this.filter[index] = new TallintTableColumnFilter(column.property, null, null);
            let col = new TallintTableColumn();
            col.setDataObj(column);
            this.tallint_table_columns.push(col);
          });
        }
        else {
          this.table_columns = jsonParse(this.table_columns);
          this.table_columns.forEach((column, index) => {
            this.filter[index] = new TallintTableColumnFilter(column.property, null, null);
            let col = new TallintTableColumn();
            col.setDataObj(column);
            this.tallint_table_columns.push(col);
          });
        }

        try {

          // console.log(this.tallint_table_columns)
          // this.tallint_table_columns = [...sortListSeq(this.tallint_table_columns, 'seq')]
          // console.log(this.tallint_table_columns)
          for (let i = 0; i < this.tallint_table_columns.length; i++) {
            for (let j = 0; j < this.tallint_table_columns.length - i - 1; j++) {
              if (this.tallint_table_columns[j].sequence > this.tallint_table_columns[j + 1].sequence) {
                let obj = Object.assign({}, this.tallint_table_columns[j]);
                this.tallint_table_columns[j] = Object.assign({}, this.tallint_table_columns[j + 1]);
                this.tallint_table_columns[j + 1] = obj;
              }
            }
          }
        } catch (err) {
          console.log(err)
        }
      }
    }
    this.change_detector.detectChanges();
  }

  filterEntries(flag) {
    let table_state = this.getTableState();
    table_state['flag'] = flag;
    if (this.fetchEntries) {
      table_state['startPage'] = this.start_page;
      table_state['limit'] = this.limit_form.value.limit || 40;
      this.fetchEntries.emit(table_state);
    }

  }

  filterModal(a, b) {

  }

  keyPressed(ev) {
  }

  scrollIntoIndex(index) {
    try {
      this.virtual_scroll.scrollToIndex(index)
    }
    catch (err) {
      console.log(err)
    }

    // if (data_row.postedOn) {
    //   console.log(eval(new Date(data_row.postedOn)) )
    //   console.log( eval (new Date()))
    //   1
    // }

  }

  rowSelected(obj) {
    if (!obj['row_selected']) {
      // this.selected_entries.push(obj);
      obj['row_selected'] = true;
    }
    else {
      let i = this.selected_entries.findIndex(data => data[this.unique_key] == obj[this.unique_key])
      if (i > -1) {
        this.selected_entries.splice(i, 1);
      }
      obj['row_selected'] = false;
    }
    this.selected_entries = this.table_records.filter(data => data.row_selected);
    if (this.selected_entries.length === this.table_records.length) {
      this.select_all = true;
    }
    else {
      this.select_all = false;
    }
    if (this.checkboxSelected) {
      this.checkboxSelected.emit(this.table_records.filter(data => data.row_selected));
    }
  }

  selectAll(flag) {
    try {

      if (flag) {
        // this.selected_entries = [];
        this.table_records.forEach(element => {
          element['row_selected'] = true;
          this.select_all = true;
          let index = this.selected_entries.indexOf(element);
          if (index == -1) {
            this.selected_entries.push(element);
          }
          if (this.unique_key && this.selected_entries && this.selected_entries.length) {
            this.selected_entries = removeDuplicate(this.selected_entries, this.unique_key);
          }
        })
      }
      else {
        this.table_records.forEach(element => {
          element['row_selected'] = false;
          // let index = this.selected_entries.indexOf(element);
          // if (index >= 0){
          //   this.selected_entries.splice(index, 1);
          // }
        })
        this.selected_entries = []
      }
      this.checkAllSelected()
      if (this.checkboxSelected) {
        this.checkboxSelected.emit(this.selected_entries);
      }
      this.change_detector.detectChanges();
      // TableCheckedValues.setCheckedValues(this.selected_entries);
    }
    catch (err) {
      console.log(err)
    }
  }

  sortColumn(column: TallintTableColumn) {
    this.pointer = true;
    if (this.enable_sort && !this.local_sort) {
      this.skip = 0;
      this.take = take;
      this.sort_flag = false;
      if (column.sort == true) {
        this.sort.setDesc(false);
      }
      else if (column.sort == false) {
        this.sort.setDesc(true);
      }
      else {
        if (this.sort && this.sort.column) {
          this.sort.setDesc(null);
        }
        column.sort = true;
        this.sort.setData(column, true);
      }
      this.filterEntries(0);
    }
    else {
      if (this.local_sort) {
        this.sort_flag = false;
        if (this.tallint_table_columns && this.tallint_table_columns.length) {
          this.tallint_table_columns.map(d => {
            if (d.colId != column.colId) {
              d.sort = null;
            }
            return d;
          })
        }
        column.sort = !column.sort;
        // if (column.sort == true) {
        //   this.sort.setDesc(false);
        // }
        // else if (column.sort == false) {
        //   this.sort.setDesc(true);
        // }
        // else {
        //   if (this.sort && this.sort.column) {
        //     this.sort.setDesc(null);
        //   }
        //   column.sort = true;
        //   this.sort.setData(column, true);
        // }
        this.table_records = this.sortArrayOfObject(this.table_records, column.property, column.sort, column);
        console.log(this.table_records)
        this.table_records = [...this.table_records]
      }
    }

  }
  sortArrayOfObject(arr, property, acc, column) {
    console.log(column)
    try {
      if (column.dataType == 'string') {
        if (acc) {
          arr = arr.sort((a, b) => a[property].localeCompare(b[property]))

        }
        else {
          arr = arr.sort((a, b) => b[property].localeCompare(a[property]))
        }
        return arr
      }
      else if (column.dataType == 'int') {
        if (acc) {
          arr = arr.sort((a, b) => b[property] - a[property])
        }
        else {
          arr = arr.sort((a, b) => a[property] - b[property])
        }
        return arr;
      }
      else if (column.dataType == 'date' || column.dataType == 'datetime') {
        if (acc) {
          arr = arr.sort((a, b) => new Date(b[property]).getTime() - new Date(a[property]).getTime())
        }
        else {
          arr = arr.sort((a, b) => new Date(a[property]).getTime() - new Date(b[property]).getTime())
        }
        return arr;
      }
      else {
        return arr
      }
    }
    catch (err) {
      return arr;
    }

  }

  getTableState() {
    let table_obj = new Object();

    table_obj['skip'] = this.skip;
    table_obj['take'] = take; //this.take;

    let filter = this.getTableFilter();

    if (filter && filter.length) {
      // table_obj['filter'] = JSON.stringify(filter);
      table_obj['filter'] = (filter);
    }

    let sort = this.getTableSort();

    if (sort && sort['selector']) {
      // table_obj['sort'] = JSON.stringify([sort]);
      table_obj['sort'] = [sort];
      table_obj['flag'] = 0;
    }

    // table_obj['totalSummary'] = JSON.stringify([{ "selector": "Id", "summaryType": "count" }]);
    table_obj['totalSummary'] = [{ "selector": "Id", "summaryType": "count" }];
    table_obj['requireTotalCount'] = true;
    return table_obj;
  }

  getTableFilter() {
    let filter_array = [];
    this.filter.forEach((element, index) => {
      element.operator = '=';
      if (element && element.property && element.value && element.operator && element.value != '') {
        filter_array.push([element.property, element.operator, element.value]);
      }
    });

    let filter_array_final = [];
    filter_array.forEach((element, index) => {
      filter_array_final.push(element);
      if (index < filter_array.length - 1) {
        filter_array_final.push('and');
      }
    })
    return filter_array_final;
  }

  dataListScroll(ev) {

  }

  getTableSort() {
    if (this.sort) {
      let sort_obj = new Object();
      sort_obj['selector'] = this.sort.selector;
      sort_obj['desc'] = this.sort.desc;
      return sort_obj;
    }
    else {
      return null;
    }
  }

  getNextBatch(e, flag?) {
    if (!this.pagination_type || this.pagination_type == 1) {
      let total = this.viewport.getDataLength();
      let end = this.viewport.getRenderedRange().end;
      if (this.fetchEntries) {
        if (e > 0 && e > this.last_scroll_index) {
          // e >= (this.table_records.length * 0.60) ||
          if (end >= total && !this.fetching_entries) {
            this.checkConditionAndFetch();
          }
        }
        this.last_scroll_index = e;
      }
    }
    else if (this.pagination_type == 2) {
      try {
        if (flag || flag == 0) {
          this.start_page = 1;
          this.current_limit = this.limit_list[flag].code;
          this.limit_form.controls.limit.patchValue(this.current_limit)
        }
        // this.scrollingIndex.emit(0)
        this.checkConditionAndFetch();

      }
      catch (err) {
        console.log(err)
      }

    }

  }

  pagination2Scrolling(ev) {
    this.scrollingIndex.emit(ev)
  }

  checkListItemClicked(row, item, column, ev) {
    console.log(row)
    console.log(item);

    row['selectedCheckListItem'] = item;
    this.cellClick(item.func || item.functionName, row, column, ev)
  }


  checkConditionAndFetch() {
    if (!this.fetching_entries && (!this.pagination_type || this.pagination_type == 1)) {
      if (this.take < this.total_count) {
        this.skip = this.take + 1;
        this.take += take;
        this.filterEntries(1);
      }
    }
    else if (this.pagination_type == 2 && !this.fetching_entries) {
      this.filterEntries(1);
    }

  }


  randomNumber() {
    return Math.floor(Math.random() * (100) + 80);
  }

  cellClick(func, data, column?, event?, quickFunc?) {
    console.log(func)
    if (func == 'display') {
      data.nested_flag = !data.nested_flag;
    }
    if (func == 'displayDocuments') {
      this.displayDocuments(data, column);
    }
    if (!data.nested_flag) {
      data.table_object = null
    }
    this.cellClicked.emit({ func: func, data: data, col_details: column, event: event, quickFunc: quickFunc });
  }

  displayDocuments(data, column) {
    try {
      if (data[column.property]) {
        data[column.property] = jsonParse(data[column.property]);
        viewDocument(data[column.property], data[column.property][0], this.dialog)
      }
    }
    catch (err) {

    }
  }
  childClick(ev) {
    console.log(ev)
    if (ev) {
      console.log(ev.func)
      if (ev.func == 'display') {
        ev.data.nested_flag = !ev.data.nested_flag;
      }
      if (!ev.data.nested_flag) {
        ev.data.table_object = null
      }
      this.cellClicked.emit({ func: ev.func, data: ev.data, col_details: ev.col_details });
    }

  }

  exportDataToExcel() {
    this.export_callback()

  }

  openColumnDetails() {
    let ref = this.dialog.open(ColumnDetailsComponent, {
      width: '720px',
      data: {
        cols: this.table_columns || [],
        table_code: this.table_code,
        filter_temp_list: this.filter_template_list || []
      }
    })
    ref.afterClosed().subscribe(res => {
      if (res) {
        this.table_columns = res || [];
        this.initializeColumns();
      }
    })
  }

  triggerCellClick(func_name, row, col?, action?, event?, quick?) {
    // console.log(row_index)
    // console.log(col_index)
    // console.log(event)
    // this.selectedRowIndex = row_index;
    // this.selectedColIndex = col_index;
    this.cellClick(func_name, row, col, event, quick)
    if (action && action.enableAutoChecked) {
      row.row_selected = false
      this.rowSelected(row);
    }
  }

  calclateTop() {
    if (!this.cdk_view_port || !this.cdk_view_port["_renderedContentOffset"]) {
      return "-0px";
    }
    let offset = this.cdk_view_port["_renderedContentOffset"];
    return `-${offset}px`;
  }



  calclateBottom() {
    this.footer_position = this.virtual_scroll['elementRef'].nativeElement.offsetHeight;
    if (!this.footer_position) {
      return this.footer_position;
    }
    return `-${this.footer_position}px`;
  }

  hideTable() {
    this.hide_table = 1;
  }

  showTable() {
    this.hide_table = 0;
  }
  tableCellClicked(rowIndex, colIndex) {
    this.timestamp = 'tallite-timestamp' + Math.floor((Math.random() * 10000) + 1) + Date.now();
    this.selectedRowIndex = rowIndex;
    this.selectedColIndex = colIndex;

  }

  insideTableEvent(ev) {
    console.log(ev)
  }

  @HostListener("window:keydown", ['$event'])

  onKeyDown(event: KeyboardEvent) {
    // console.log(event)
    // if (event && this.timestamp) {
    //   if (event.keyCode == 40) { //Arrow down should shift row by 1
    //     this.selectedRowIndex += 1;
    //   }
    //   else if (event.keyCode == 38) { //Arrow up should shift row by -1
    //     if (this.selectedRowIndex > 1) {
    //       this.selectedRowIndex -= 1;
    //     }

    //   }
    //   else if (event.keyCode == 37) { //Arrow left should shift column by -1
    //     if (this.selectedColIndex > 1) {
    //       this.selectedColIndex -= 1;
    //     }
    //   }
    //   else if (event.keyCode == 39) { //Arrow right should shift row by 1
    //     this.selectedColIndex += 1;
    //   }

    //   // if (document.getElementById(this.timestamp + this.random_id + 'tallite-td' + this.selectedRowIndex + this.selectedColIndex)) {
    //   //   setTimeout(() => {
    //   //     document.getElementById(this.timestamp + this.random_id + 'tallite-td' + this.selectedRowIndex + this.selectedColIndex).scrollIntoView()
    //   //   })
    //   // }
    //   console.log(this.calclateTop())
    //   // setTimeout(() => {
    //   //   this.viewport.scrollToIndex(this.selectedRowIndex)
    //   // }, 200)

    // }
  }

}

@Component({
  selector: '[table-row]',
  templateUrl: './tallint-table-row.html',
  styleUrls: ['./tallint-table.component.scss']
})
export class TallintTableRowComponent {
  @Input() row;
  @Input() rowSelected;
  @Input() cellClick;
  @Input() tallint_table_columns;
  @Input() multi_select;
  @Input() edit;
  @Input() nested;
  @Input() index;
  @Input() column;
  @Input() padding_exp;
  @Input() style;

  @Input() form_fields;
  @Input() form_masters;
  @Input() formatted_row;

  display_row;

  close = '</tr>'
  constructor(
  ) {

  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.formatted_row) {
      this.display_row = this.row.processed_data;
      ;

    }
    else {
      this.display_row = this.row;
    }
  }

  triggerCellClick(func_name, col?) {
    this.cellClick(func_name, this.row, col)
  }

}

export class TallintTableColumn {
  title: string;
  property: string;
  sort: boolean;
  visible: boolean;
  width: string;
  style: any;
  cell_filter: string;
  dataType: string;
  cell_class: string;
  cell_template: string;
  description: string;
  ascending: number;
  grouping: number;
  form_code: string;
  status: number;
  function_name: string;
  label_code: string;

  sub_module_code: string;
  module_code: string;

  conditions: any;
  sequence: number;
  colId: number;
  seq: number;
  quick: string;
  conditionSeq: number;
  uiConfig: any;

  constructor() { }

  setData(title, property, dataType?) {
    this.title = title;
    this.property = property;
    this.dataType = dataType === 'date' ? dataType : 'string';
  }

  setDataObj(obj) {
    this.label_code = obj.label_code;
    this.seq = obj.seq;

    this.sub_module_code = obj.sub_module_code;
    this.module_code = obj.module_code;
    this.title = obj.title;
    this.property = obj.property;
    this.sort = obj.sort;
    this.visible = obj.visible;
    this.width = obj.width;
    this.style = obj.style;
    this.cell_filter = obj.cell_filter;
    this.dataType = obj.dataType;
    this.cell_class = obj.cell_class;
    this.cell_template = obj.cell_template;
    this.description = obj.description;
    this.ascending = obj.ascending;
    this.grouping = obj.grouping;
    this.form_code = obj.form_code;
    this.status = obj.status;
    this.function_name = obj.field_name;
    this.label_code = obj.label_code;
    this.conditions = obj.conditions;
    this.sequence = obj.sequence;
    this.colId = obj.colId;
    this.quick = obj.quick;
    this.conditionSeq = obj.conditionSeq;
    this.uiConfig = obj.uiConfig;
  }
}

export class TallintTableColumnFilter {
  property: string;
  operator: string;
  value: string;


  constructor(
    property = null,
    operator = null,
    value = null
  ) {
    this.property = property;
    this.operator = operator;
    this.value = value;
  }
}

export class TallintTableColumnSort {
  selector: string;
  desc: boolean;
  column: TallintTableColumn;

  constructor() {
  }

  setData(column = null, desc = null) {
    if (column) {
      this.selector = column.property;
      this.desc = desc;
      this.column = column;
    }
  }
  setDesc(desc) {
    this.desc = desc;
    this.column.sort = desc;
  }
}


@Pipe({
  name: 'TableRowCSS'
})
export class TableRowCSS implements PipeTransform {
  transform(input: any, row): any {
    let css_class = '';
    if (input.req_res_id == 15880) {
      css_class += 'red';
    }

  }
}

@Pipe({
  name: 'InnerHTMLToText'
})
export class InnerHTMLToText implements PipeTransform {
  // constructor(private sanitizer: DomSanitizer) {

  // }
  transform(input: any): any {
    let el = document.createElement('span');
    el.innerHTML = input;
    return el.innerText || el.title;

  }
}

@Pipe({
  name: 'CheckGridConditions'
})
export class CheckGridConditions implements PipeTransform {
  transform(input: any, data: any): any {
    let status = true;
    try {
      if (input && input.length) {
        status = eval(input)
      }
    }
    catch (err) {
      console.log(err);
    }
    return status;
  }
}

@Pipe({
  name: 'checkStyle'
})
export class checkStyleCondition implements PipeTransform {
  transform(style: any, data_row: any, column, isHeader?): any {
    if (style && style.list && style.list.length) {
      let currentStyle;
      for (let i = 0; i < style.list.length; i++) {
        let item = style.list[i];
        if (isHeader && item.applyForHeader) {
          if (item.rowOrCell == 1) {
            return {
              'background-color': item.bgTrans ? 'transparent' : item.bgColor,
              'color': item.fontColor,
              'font-weight': item.fontWeight,
              'font-style': item.fontStyle,
            };
          }
          else if (item.rowOrCell == 2) {
            if (column['property'] == style.displayRefColumnName) {
              return {
                'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                'color': item.fontColor,
                'font-weight': item.fontWeight,
                'font-style': item.fontStyle,
              };
            }
          }
        }
        else if (!isHeader && !item.applyForHeader) {
          if (item.condition && item.condition != '') {
            try {
              if (eval(item.condition)) {
                if (item.rowOrCell == 1) {
                  return {
                    'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                    'color': item.fontColor,
                    'font-weight': item.fontWeight,
                    'font-style': item.fontStyle,
                  };
                }
                else if (item.rowOrCell == 2) {
                  if (column['property'] == style.displayRefColumnName) {
                    return {
                      'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                      'color': item.fontColor,
                      'font-weight': item.fontWeight,
                      'font-style': item.fontStyle,
                    };
                  }
                }
              }
            }
            catch (err) {
              console.log('Due to dynamic condition false, please check' + err)
            }

          }
          else if (item.code == data_row[style.compareRefColumnName] && data_row[style.compareRefColumnName]) {
            if (item.rowOrCell == 1) {
              return {
                'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                'color': item.fontColor,
                'font-weight': item.fontWeight,
                'font-style': item.fontStyle,
              };
            }
            else if (item.rowOrCell == 2) {
              if (column['property'] == style.displayRefColumnName) {
                return {
                  'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                  'color': item.fontColor,
                  'font-weight': item.fontWeight,
                  'font-style': item.fontStyle,
                };
              }
            }
          }
          else {
            if (item.rowOrCell == 1) {
              return {
                'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                'color': item.fontColor,
                'font-weight': item.fontWeight,
                'font-style': item.fontStyle,
              };
            }
            else if (item.rowOrCell == 2) {
              if (column['property'] == style.displayRefColumnName) {
                return {
                  'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                  'color': item.fontColor,
                  'font-weight': item.fontWeight,
                  'font-style': item.fontStyle,
                };
              }
            }
          }
        }
      }
    }
  }
}

@Pipe({
  name: 'checkStyleRow'
})
export class checkStyleConditionRow implements PipeTransform {
  transform(columns, data_row, isHeader?): any {
    if (columns && columns.length) {
      let arr = []
      columns.forEach(col => {
        if (col && col.style) {
          if (col.style.list && col.style.list.length) {
            let l = col.style.list.filter(d => d.rowOrCell == 1);
            if (l && l.length) {
              if (arr && arr.length) {
                arr = [...arr, ...l]
              }
              else {
                arr = l
              }
            }
          }
        }
      })
      if (arr && arr.length) {
        try {
          arr = sortListSeq(arr, 'conditionSeq')
          for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            if (item.condition && item.condition != '') {
              try {
                if (eval(item.condition)) {
                  if (item.rowOrCell == 1) {
                    return {
                      'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                      'color': item.fontColor,
                      'font-weight': item.fontWeight,
                      'font-style': item.fontStyle,
                    };
                  }
                }
              }
              catch (err) {
                console.log('Due to dynamic condition false, please check' + err)
              }

            }
            else {
              if (item.rowOrCell == 1) {
                return {
                  'background-color': item.bgTrans ? 'transparent' : item.bgColor,
                  'color': item.fontColor,
                  'font-weight': item.fontWeight,
                  'font-style': item.fontStyle,
                };
              }

            }
          }
        }
        catch (err) {
          console.log(err)
        }



      }
      else {
        return {}
      }
    }
    else {
      return {}
    }



  }
}

@Pipe({
  name: 'checkTemplate'
})
export class checkTemplateCondition implements PipeTransform {
  transform(style: any, data_row: any, column, isHeader?): any {
    if (style && style.displayRefColumnName == column.property) {
      if (style && style.list && style.list.length) {
        let currentStyle;
        for (let i = 0; i < style.list.length; i++) {
          let item = style.list[i];

          if (item.cellTemplate) {
            item.cellTemplate = jsonParse(item.cellTemplate)
            if (item.condition && item.condition != '') {
              try {
                if (eval(item.condition)) {
                  return item.cellTemplate;
                }
              }
              catch (err) {
                console.log('Due to dynamic condition false, please check' + err)
              }

            }
            else {
              return item.cellTemplate
            }
          }

        }
      }
    }
    // var date1 = new Date(data_row.postedOn);
    // var date2 = new Date();

    // var Difference_In_Time = date2.getTime() - date1.getTime();

    // var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24)) ;
    // console.log(Difference_In_Days);
    // if(Difference_In_Days > 3 && data_row.totalResCount==0){
    //   1;
    // }
    // else{
    //   0;
    // }


  }
}

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe {

  constructor(private sanitizer: DomSanitizer) {

  }

  transform(style) {
    return this.sanitizer.bypassSecurityTrustStyle(
      style);
  }
}















// import { MatDialog } from '@angular/material/dialog';
// import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, Output, EventEmitter, ElementRef, ViewChild, Renderer, Renderer2, AfterViewInit, Pipe, PipeTransform } from '@angular/core';
// import { ColumnDetailsComponent } from './column-details/column-details.component';
// import { jsonParse } from 'src/app/app.component';
// import { DomSanitizer } from '@angular/platform-browser';
// import { CdkVirtualScrollViewport, ScrollDispatcher } from '@angular/cdk/scrolling';
// import { filter } from 'rxjs/operators';
// import * as moment from 'moment';


// export const skip = 0;
// export const take = 20;

// @Component({
//   selector: 'app-tallint-table',
//   templateUrl: './tallint-table.component.html',
//   styleUrls: ['./tallint-table.component.scss'],
//   providers: [
//   ]
// })

// export class TallintTableComponent implements OnInit, OnChanges, AfterViewInit {

//   @Input() table_records = [];
//   @Input() table_columns = [];
//   @Input() total_count;
//   @Input() multi_select;
//   @Input() loading;
//   @Input() edit;
//   @Input() selected_entries;
//   @Input() display_filter;
//   @Output() fetchEntries = new EventEmitter();
//   @Output() checkboxSelected = new EventEmitter();
//   @Output() cellClicked = new EventEmitter();
//   @Input() nested;
//   @Input() fetching_entries;
//   @Input() item_size;
//   @Input() export;
//   @Input() export_records;
//   @Input() export_callback;
//   @Input() export_ready;
//   @Input() file_name;
//   @Input() table_code;
//   @Input() filter_template_list;
//   @Input() grid_configuration;

//   @Input() form_masters;
//   @Input() form_fields;
//   @Input() formatted_table_records;

//   @Input() enable_sort;

//   @Input() table_configuration_flag;
//   @Input() enable_summary = 1;
//   @Input() summary;

//   start: any = undefined;
//   pressed: boolean = false;
//   startX: any;
//   startWidth: any;
//   Math = Math;
//   random_width = [];
//   display_subrow = false;
//   sort_flag = true;
//   pointer = true;
//   @ViewChild(CdkVirtualScrollViewport, { static: false }) viewport: CdkVirtualScrollViewport;
//   // fetchMultipleEntries: TableCheckedValues = new TableCheckedValues();

//   // fetching_entries;
//   // selected_entries = [];
//   // selected_entries = [];

//   skip;
//   take;

//   table_height;
//   table_max_height;

//   filter: Array<TallintTableColumnFilter>;
//   sort: TallintTableColumnSort;

//   select_all = false;

//   tallint_table_columns = [];
//   hide_table;

//   parseInt = parseInt;

//   @ViewChild("virtual_scroll", { static: false }) virtual_scroll: CdkVirtualScrollViewport;
//   @ViewChild("tallint_table", { static: false }) tallint_table_ref: ElementRef;
//   @ViewChild("virtual_scroll", { static: false }) cdk_view_port: CdkVirtualScrollViewport;
//   table = document.getElementById('tableId');

//   last_scroll_index = 0;

//   footer_position;

//   constructor(
//     private change_detector: ChangeDetectorRef,
//     private renderer: Renderer2,
//     private dialog: MatDialog,
//     private sanitizer: DomSanitizer,
//     private scrollDispatcher: ScrollDispatcher
//   ) { }

//   ngOnInit() {
//     console.log(this.table_columns);
//     console.log(this.summary);
//     if (!this.selected_entries) {
//       this.selected_entries = [];
//     }

//     // fromEvent(window, 'resize')
//     // 	.pipe(
//     // 		debounceTime(10),
//     // 		takeUntil(this.destroy$),
//     // 	)
//     // 	.subscribe(() => this.viewportComponent.checkViewportSize())
//     // ;
//     this.table_configuration_flag = false;
//     // this.filterEntries();
//     if (this.loading == null || undefined) {
//       this.loading = false;
//     }
//     for (let i = 0; i < 14; i++) {
//       this.random_width[i] = [];
//       for (let j = 0; j < 10; j++) {
//         this.random_width[i][j] = this.randomNumber() + 'px';
//       }
//     }
//     this.init();
//     // this.change_detector.det


//     // if (this.formatted_table_records && this.table_records && this.table_records.length) {
//     //   for (let i = 0; i < this.table_records.length; i++) {
//     //     this.table_records[i].data = this.formatted_table_records[i];
//     //   }
//     // }
//   }

//   ngAfterViewInit() {
//     console.log(this.virtual_scroll['elementRef'].nativeElement.offsetHeight);
//     this.footer_position = this.virtual_scroll['elementRef'].nativeElement.offsetHeight;

//     // this.scrollDispatcher.scrolled().pipe(
//     //   filter(event => this.virtual_scroll.getRenderedRange().end === this.virtual_scroll.getDataLength())
//     // ).subscribe(event => {
//     //   console.log(event);
//     //   this.getNextBatch(event);
//     //   //this.cd.detectChanges();
//     // })

//   }

//   resizeTable(event, column) {
//     this.start = event.target;
//     this.pressed = true;
//     setTimeout(() => {
//       this.pointer = false;
//     })

//     this.startX = event.pageX;
//     this.startWidth = this.start.clientWidth;
//     this.renderer.listen('window', 'mousemove', (event) => {
//       if (this.pressed) {
//         let width = this.startWidth + (event.pageX - this.startX);
//         // let index = this.start.cellIndex;
//         if (column != null) {
//           // if (column.width) {
//           //   // column.width += width;
//           // }
//           // else {
//           column.width = width;
//           // }
//         }
//         event.preventDefault();
//         this.change_detector.detectChanges();
//       }
//     });
//     this.renderer.listen('window', 'mouseup', (event) => {
//       column = null;
//       if (this.pressed) {
//         this.pressed = false;
//         this.pointer = true;
//       }
//     });
//   }

//   init() {
//     // this.virtual_scroll.nativeElement.scrollTop = 0;
//     // if (this.virtual_scroll && this.virtual_scroll['elementRef'] && this.virtual_scroll['elementRef'].nativeElement) {
//     //   this.virtual_scroll['elementRef'].nativeElement.scroll(0, 0);
//     // }
//     this.filter = [];
//     this.skip = skip;
//     this.take = take;
//     this.sort = new TallintTableColumnSort();

//     this.table_height = this.total_count ? (this.total_count * 24.67) + 60 : 100;
//     // this.table_max_height = (this.total_count * 25.33) + 60;
//     if (this.multi_select) {
//       try {
//         if (this.selected_entries.length) {
//           let flag = true;
//           this.selected_entries.forEach(element => {
//             if (this.table_records.indexOf(element) == -1) {
//               flag = false;
//             }
//           });
//           this.select_all = flag && this.selected_entries.length == this.table_records.length;
//         }
//         else {
//           this.select_all = false;
//         }
//       } catch (err) {
//         this.select_all = false;
//       }
//     }


//     this.initializeColumns();
//     this.change_detector.detectChanges();
//   }

//   ngOnChanges(ev) {
//     if (ev.total_count || (ev.table_columns && ev.table_columns.length)) {
//       this.init();
//     }
//     if (ev.table_records) {
//       this.fetching_entries = 0;
//       this.table_records = ev.table_records.currentValue || this.table_records; //getting lastest update data or update existing records
//       this.change_detector.detectChanges();

//     }
//     // if (this.export_ready && this.export_records && this.export_records.length > 0) {
//     //   let exp_data = [];
//     //   let rows = {};
//     //   this.table_records.forEach(row => {
//     //     this.tallint_table_columns.forEach(col => {
//     //       if (col['visible']) {
//     //         let prop = col['property']
//     //         let titles = col['title']
//     //         rows[titles] = row[prop];
//     //       }
//     //     })
//     //     if (rows)
//     //       exp_data.push(rows);
//     //     rows = {};
//     //   })
//     //   this.export_excel_srv.exportExcel(exp_data, this.file_name || 'Details');
//     //   this.export_ready = false;
//     //   this.export_records = [];
//     //   this.change_detector.detectChanges();
//     // }

//   }

//   exportToExcelParent() {
//     if (this.export_records && this.export_records.length > 0) {
//       let exp_data = [];
//       let rows = {};
//       this.export_records.forEach(row => {
//         this.tallint_table_columns.forEach(col => {
//           if (col['visible']) {
//             let prop = col['property']
//             let titles = col['title']
//             rows[titles] = row[prop];
//           }
//         })
//         if (rows)
//           exp_data.push(rows);
//         rows = {};
//       })
//       // this.export_excel_srv.exportExcel(exp_data, this.file_name || 'Details');
//       // this.export_records = [];
//       // this.export_ready = false;
//       // this.change_detector.detectChanges();
//     }
//   }

//   initializeColumns() {
//     if (this.table_records && this.table_records.length) {
//       if (!(this.table_columns && this.table_columns.length)) {
//         let columns = Object.keys(this.table_records[0]);
//         if (columns && columns.length) {
//           this.tallint_table_columns = [];
//           columns.forEach((column, index) => {
//             let col = new TallintTableColumn();

//             try {
//               if (isNaN(this.table_records[0][column])) {
//                 var d = moment(this.table_records[0][column], moment.ISO_8601);
//                 if (d.isValid()) {
//                   col.setData(column, column, 'date');
//                 }
//                 else {
//                   col.setData(column, column);
//                 }

//               }
//               else {
//                 col.setData(column, column);
//               }
//               //&& isNaN(this.table_records[0][column]))
//             } catch (error) {
//               col.setData(column, column);
//             }
//             this.filter[index] = new TallintTableColumnFilter(column, null, null);
//             col.visible = true;
//             this.tallint_table_columns.push(col);
//           })
//         }
//       }
//       else if (this.table_columns && this.table_columns.length) {
//         this.tallint_table_columns = [];
//         if (typeof this.table_columns == 'object' && this.table_columns.length) {
//           this.table_columns.forEach((column, index) => {
//             this.filter[index] = new TallintTableColumnFilter(column.property, null, null);
//             let col = new TallintTableColumn();
//             col.setDataObj(column);
//             this.tallint_table_columns.push(col);
//           });
//         }
//         else {
//           this.table_columns = jsonParse(this.table_columns);
//           this.table_columns.forEach((column, index) => {
//             this.filter[index] = new TallintTableColumnFilter(column.property, null, null);
//             let col = new TallintTableColumn();
//             col.setDataObj(column);
//             this.tallint_table_columns.push(col);
//           });
//         }

//         try {
//           for (let i = 0; i < this.tallint_table_columns.length; i++) {
//             for (let j = 0; j < this.tallint_table_columns.length - i - 1; j++) {
//               if (this.tallint_table_columns[j].sequence > this.tallint_table_columns[j + 1].sequence) {
//                 let obj = Object.assign({}, this.tallint_table_columns[j]);
//                 this.tallint_table_columns[j] = Object.assign({}, this.tallint_table_columns[j + 1]);
//                 this.tallint_table_columns[j + 1] = obj;
//               }
//             }
//           }
//         } catch (err) { }
//       }
//     }
//     this.change_detector.detectChanges();
//   }

//   filterEntries(flag) {
//     let table_state = this.getTableState();
//     if (flag || flag == 0) {
//       table_state['flag'] = flag;
//     }
//     this.fetching_entries = 1;
//     if (this.fetchEntries) {
//       this.fetchEntries.emit(table_state);
//     }

//   }

//   keyPressed(ev) {
//   }

//   rowSelected(obj) {
//     if (!obj['row_selected']) {
//       this.selected_entries.push(obj);
//       obj['row_selected'] = true;
//     }
//     else {
//       obj['row_selected'] = false;
//       if (this.selected_entries.indexOf(obj) >= 0) {
//         this.selected_entries.splice(this.selected_entries.indexOf(obj), 1);
//       }
//     }
//     if (this.selected_entries.length === this.table_records.length) {
//       this.select_all = true;
//     }
//     else {
//       this.select_all = false;
//     }
//     if (this.checkboxSelected) {
//       this.checkboxSelected.emit(this.selected_entries);

//     }
//   }

//   selectAll(flag) {
//     try {
//       if (this.selected_entries.length === this.table_records.length) {
//         this.select_all = true;
//       }
//       else {
//         this.select_all = false;
//       }
//       if (flag) {
//         // this.selected_entries = [];
//         this.table_records.forEach(element => {
//           element['row_selected'] = true;
//           this.select_all = true;
//           let index = this.selected_entries.indexOf(element);
//           if (index == -1)
//             this.selected_entries.push(element);
//         })
//       }
//       else {
//         this.table_records.forEach(element => {
//           element['row_selected'] = false;
//           this.select_all = false;
//           let index = this.selected_entries.indexOf(element);
//           if (index >= 0)
//             this.selected_entries.splice(index, 1);
//         })
//       }

//       if (this.checkboxSelected) {
//         this.checkboxSelected.emit(this.selected_entries);
//       }
//       this.change_detector.detectChanges();
//       // TableCheckedValues.setCheckedValues(this.selected_entries);
//     }
//     catch (err) {

//     }
//   }

//   sortColumn(column: TallintTableColumn) {
//     this.pointer = true;
//     if (this.enable_sort) {
//       this.skip = 0;
//       this.take = take;
//       this.sort_flag = false;
//       if (column.sort == true) {
//         this.sort.setDesc(false);
//       }
//       else if (column.sort == false) {
//         this.sort.setDesc(true);
//       }
//       else {
//         if (this.sort && this.sort.column) {
//           this.sort.setDesc(null);
//         }
//         column.sort = true;
//         this.sort.setData(column, true);
//       }
//       this.filterEntries(0);
//     }
//   }

//   getTableState() {
//     let table_obj = new Object();

//     table_obj['skip'] = this.skip;
//     table_obj['take'] = take; //this.take;

//     let filter = this.getTableFilter();

//     if (filter && filter.length) {
//       // table_obj['filter'] = JSON.stringify(filter);
//       table_obj['filter'] = (filter);
//     }

//     let sort = this.getTableSort();

//     if (sort && sort['selector']) {
//       // table_obj['sort'] = JSON.stringify([sort]);
//       table_obj['sort'] = [sort];
//       table_obj['flag'] = 0;
//     }

//     // table_obj['totalSummary'] = JSON.stringify([{ "selector": "Id", "summaryType": "count" }]);
//     table_obj['totalSummary'] = [{ "selector": "Id", "summaryType": "count" }];
//     table_obj['requireTotalCount'] = true;
//     return table_obj;
//   }

//   getTableFilter() {
//     let filter_array = [];
//     this.filter.forEach((element, index) => {
//       element.operator = '=';
//       if (element && element.property && element.value && element.operator && element.value != '') {
//         filter_array.push([element.property, element.operator, element.value]);
//       }
//     });

//     let filter_array_final = [];
//     filter_array.forEach((element, index) => {
//       filter_array_final.push(element);
//       if (index < filter_array.length - 1) {
//         filter_array_final.push('and');
//       }
//     })
//     return filter_array_final;
//   }

//   getTableSort() {
//     if (this.sort) {
//       let sort_obj = new Object();
//       sort_obj['selector'] = this.sort.selector;
//       sort_obj['desc'] = this.sort.desc;
//       return sort_obj;
//     }
//     else {
//       return null;
//     }
//   }

//   getNextBatch(e) {
//     let total = this.viewport.getDataLength();
//     let end = this.viewport.getRenderedRange().end;
//     console.log(total, end)
//     if (this.fetchEntries) {
//       if (e > 0 && e > this.last_scroll_index) {
//         // e >= (this.table_records.length * 0.60) ||
//         if (end >= total && !this.fetching_entries) {
//           this.checkConditionAndFetch();
//         }
//       }
//       this.last_scroll_index = e;
//     }
//   }

//   checkConditionAndFetch() {
//     if (this.take < this.total_count) {
//       this.skip = this.take + 1;
//       this.take += take;
//       this.filterEntries(1);
//     }
//   }


//   randomNumber() {
//     return Math.floor(Math.random() * (100) + 80);
//   }

//   cellClick(func, data, column?) {
//     this.cellClicked.emit({ func: func, data: data, col_details: column });
//     if (func == 'display') {
//       data.nested_flag = !data.nested_flag;
//     }
//   }

//   exportDataToExcel() {
//     this.export_callback()

//   }

//   openColumnDetails() {
//     let ref = this.dialog.open(ColumnDetailsComponent, {
//       width: '720px',
//       data: {
//         cols: this.table_columns || [],
//         table_code: this.table_code,
//         filter_temp_list: this.filter_template_list || []
//       }
//     })
//     ref.afterClosed().subscribe(res => {
//       if (res) {
//         this.table_columns = res || [];
//         this.initializeColumns();
//       }
//     })
//   }

//   triggerCellClick(func_name, row, col?) {
//     this.cellClick(func_name, row, col)
//   }

//   calclateTop() {
//     if (!this.cdk_view_port || !this.cdk_view_port["_renderedContentOffset"]) {
//       return "-0px";
//     }
//     let offset = this.cdk_view_port["_renderedContentOffset"];
//     return `-${offset}px`;
//   }

//   calclateBottom() {
//     this.footer_position = this.virtual_scroll['elementRef'].nativeElement.offsetHeight;
//     if (!this.footer_position) {
//       return this.footer_position;
//     }
//     return `-${this.footer_position}px`;
//   }

//   hideTable() {
//     this.hide_table = 1;
//   }

//   showTable() {
//     this.hide_table = 0;
//   }

// }

// @Component({
//   selector: '[table-row]',
//   templateUrl: './tallint-table-row.html',
//   styleUrls: ['./tallint-table.component.scss']
// })
// export class TallintTableRowComponent {
//   @Input() row;
//   @Input() rowSelected;
//   @Input() cellClick;
//   @Input() tallint_table_columns;
//   @Input() multi_select;
//   @Input() edit;
//   @Input() nested;
//   @Input() index;
//   @Input() column;
//   @Input() padding_exp;
//   @Input() style;

//   @Input() form_fields;
//   @Input() form_masters;
//   @Input() formatted_row;

//   display_row;

//   close = '</tr>'
//   constructor(
//   ) {

//   }

//   ngOnInit(): void {
//     //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
//     //Add 'implements OnInit' to the class.
//     if (this.formatted_row) {
//       this.display_row = this.row.processed_data;
//       ;

//     }
//     else {
//       this.display_row = this.row;
//     }
//   }

//   triggerCellClick(func_name, col?) {
//     this.cellClick(func_name, this.row, col)
//   }

// }

// export class TallintTableColumn {
//   title: string;
//   property: string;
//   sort: boolean;
//   visible: boolean;
//   width: string;
//   cell_filter: string;
//   dataType: string;
//   cell_class: string;
//   cell_template: string;
//   description: string;
//   ascending: number;
//   grouping: number;
//   form_code: string;
//   status: number;
//   function_name: string;
//   label_code: string;
//   color_property: string
//   sub_module_code: string;
//   module_code: string;

//   conditions: any;
//   sequence: number;

//   constructor() { }

//   setData(title, property, dataType?) {
//     this.title = title;
//     this.property = property;
//     this.dataType = dataType === 'date' ? dataType : 'string';
//   }

//   setDataObj(obj) {
//     this.label_code = obj.label_code;

//     this.sub_module_code = obj.sub_module_code;
//     this.module_code = obj.module_code;
//     this.title = obj.title;
//     this.property = obj.property;
//     this.sort = obj.sort;
//     this.visible = obj.visible;
//     this.width = obj.width;
//     this.cell_filter = obj.cell_filter;
//     this.dataType = obj.dataType;
//     this.cell_class = obj.cell_class;
//     this.cell_template = obj.cell_template;
//     this.description = obj.description;
//     this.ascending = obj.ascending;
//     this.grouping = obj.grouping;
//     this.form_code = obj.form_code;
//     this.status = obj.status;
//     this.function_name = obj.field_name;
//     this.label_code = obj.label_code;
//     this.conditions = obj.conditions;
//     this.sequence = obj.sequence;
//     this.color_property = obj.color_property;
//   }
// }

// export class TallintTableColumnFilter {
//   property: string;
//   operator: string;
//   value: string;


//   constructor(
//     property = null,
//     operator = null,
//     value = null
//   ) {
//     this.property = property;
//     this.operator = operator;
//     this.value = value;
//   }
// }

// export class TallintTableColumnSort {
//   selector: string;
//   desc: boolean;
//   column: TallintTableColumn;

//   constructor() {
//   }

//   setData(column = null, desc = null) {
//     if (column) {
//       this.selector = column.property;
//       this.desc = desc;
//       this.column = column;
//     }
//   }
//   setDesc(desc) {
//     this.desc = desc;
//     this.column.sort = desc;
//   }
// }


// @Pipe({
//   name: 'TableRowCSS'
// })
// export class TableRowCSS implements PipeTransform {
//   transform(input: any, row): any {
//     let css_class = '';
//     if (input.req_res_id == 15880) {
//       css_class += 'red';
//     }

//   }
// }

// @Pipe({
//   name: 'CheckGridConditions'
// })
// export class CheckGridConditions implements PipeTransform {
//   transform(input: any, data: any): any {
//     let status = true;
//     try {
//       if (input && input.length) {
//         status = eval(input)
//       }
//     }
//     catch (err) {
//       console.log(err);
//     }
//     return status;
//   }
// }

// @Pipe({ name: 'safeHtml' })
// export class SafeHtmlPipe {

//   constructor(private sanitizer: DomSanitizer) {

//   }

//   transform(style) {
//     return this.sanitizer.bypassSecurityTrustStyle(style);
//   }
// }





